import { createSelector } from '@ngrx/store';
import { hasCalcs } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/calcs/calcs.selectors';
import { hasCorrelations } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/correlations/correlations.selectors';
import { getSecurities, hasSecurities, } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/securities/securities.selectors';
import { getSecurityGroup, getSecuritylistName, getSecuritylistSecurityId, } from 'ChartApp/ts/state/base-chart.selectors';
import { INDICATOR } from 'NewAngular/constants/core.constants';
import { isSecurityType } from 'NewAngular/utils/security-utils';
const hasSecurityList = createSelector(getSecuritylistName, getSecurityGroup, getSecuritylistSecurityId, (securitylistName, securityGroup, securitylistSecurityId) => {
    return securitylistName && securityGroup && securitylistSecurityId;
});
export const hasValidRequestData = createSelector(hasCalcs, hasCorrelations, hasSecurities, hasSecurityList, getSecurityGroup, getSecurities, (_hasCalcs, _hasCorrelations, _hasSecurities, _hasSecurityList, _getSecurityGroup, securities) => {
    // If we have correlations, short-circuit and return true
    if (_hasCorrelations)
        return true;
    // If any of our securities are indicators, short-circuit and
    // return true because indicators don't need calcs to be valid.
    if (_hasSecurities &&
        securities.some((security) => isSecurityType(INDICATOR, security.id))) {
        return true;
    }
    // If security list is an indicator securitylist, return true since indicators do not need calcs
    if (_hasSecurityList && _getSecurityGroup === INDICATOR) {
        return true;
    }
    // Check that we have a combination of:
    // A) calcs and securities
    // B) calcs and a security list
    return _hasCalcs && (_hasSecurities || _hasSecurityList);
});
